import fixtures from './variables/worldcupfixtures.json'
import ISOcodes from './variables/ISOcodes.json'
import { Link, useNavigate } from 'react-router-dom';
import {useState, useEffect} from 'react'

// import { fetchFixtures } from '../../API/football'


export default function Example() {

  // const [worldcupFixtures, setWorldcupFixtures] = useState([]);

  // useEffect(() => {
  //   fetchFixtures(1, 2022).then(data => {
  //     setWorldcupFixtures(data)
  //   })
  // }, [])

  // console.log(worldcupFixtures)

  const navigate = useNavigate();
  const setMatch = (id, teamA, teamB, aLogo, bLogo, time, date, venue) => {
    navigate('/game', { state: { _id: id, home: teamA, away: teamB, homeLogo: aLogo, awayLogo: bLogo, time: time, date: date, stadium: venue } });
  }

  // function custom_sort(a, b) {
  //   return new Date(b.fixture.Date).getTime() - new Date(a.fixture.date).getTime();
  // }

  // fixtures.sort(custom_sort)

  const date = new Date()
  const now = date.toISOString()

  // function setHomeISO(team) {
  //   const code = ISOcodes.team
  //   return code
  // }

  return (
    <div >
      <div className="max-w-4xl mx-auto px-4 py-1 sm:px-6 sm:pt-20 sm:pb-24 lg:max-w-7xl lg:pt-10 lg:px-8">
        <ul
          time="list"
          className="grid grid-cols-1 py-10 gap-6 sm:grid-cols-2 lg:grid-cols-3"
        >
          {fixtures.map((fixture) => {
            if (fixture.fixture.date >= now) {
              return (
                <li key={fixture.fixture.id} className="col-span-1 rounded-lg bg-white bg-opacity-70 hover:bg-gray-100 shadow">
                  <a href='' onClick={() => { setMatch(fixture._id, fixture.teams.home.name, fixture.teams.away.name, fixture.teams.home.logo, fixture.teams.away.logo, fixture.fixture.date.substring(11, 16), fixture.fixture.date.substring(0, 10), fixture.fixture.venue.name) }}>
                    <div>
                      <div className="-mt-px flex">
                        <div className="flex w-0 flex-1">
                          <div className="mx-auto py-5 flex-shrink-0 flex justify-center">
                            <img
                              className="h-14 w-16"
                              src={fixture.teams.home.logo}
                              alt="Logo"
                            />

                          </div>
                        </div>
                        <div className="w-1"></div>
                        <div className="-ml-px flex w-0 flex-1">
                          <div className="mx-auto py-5 flex-shrink-0 flex items-center justify-center">
                            <img
                              className="h-14 w-16"
                              src={fixture.teams.away.logo}
                              alt="Logo"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="-mt-px items-center flex">
                        <div className="flex w-0 flex-1">
                          <div className="relative -mr-px inline-flex w-0 flex-1 items-center justify-center rounded-bl-lg border border-transparent py-4 text-3xl font-bold text-gray-600 hover:text-purple-600">
                            <span className="justify-center">{fixture.teams.home.name}</span>
                          </div>
                        </div>
                        <div className="flex w-1">
                          <div className="justify-center flex w-0 flex-1">
                            <span className="text-4xl font-bold text-center text-gray-600 hover:text-purple-600 tracking-tight">
                              V
                            </span>
                          </div>
                        </div>
                        <div className="-ml-px flex w-0 flex-1">
                          <div className="relative inline-flex w-0 flex-1 items-center justify-center rounded-br-lg border border-transparent py-4 text-3xl font-bold text-gray-600 hover:text-purple-600">
                            <span className="justify-center">{fixture.teams.away.name}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex w-full items-center justify-between space-x-6 p-6">
                      <div className="flex-1 truncate">
                        <div className="flex items-center space-x-3">
                          <h3 className="truncate text-sm font-medium text-gray-900">
                            {fixture.fixture.date.substring(0, 10)}
                          </h3>
                          <span className="inline-block flex-shrink-0 rounded-full bg-green-100 px-2 py-0.5 text-xs font-medium text-green-800">
                            {fixture.fixture.date.substring(11, 16)}
                          </span>
                        </div>
                        <p className="mt-1 truncate text-sm text-gray-500">
                          {fixture.fixture.venue.name}
                        </p>
                      </div>
                    </div>
                  </a>
                </li>
              )
            }
          })}
        </ul>
      </div>
    </div>
  );
}

